import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {PersonDescription} from "./PersonDescription";

export const AuthorsSection = () => {
    const author = useSelector((state: IRPStore) => state.article.detail.article?.author);
    const expert = useSelector((state: IRPStore) => state.article.detail.article?.expert);

    const showAuthor = !!(author?.image_url && author.description.length > 0);
    const showExpert = !!(expert?.image_url && expert.description.length > 0);

    if (!showAuthor && !showExpert) {
        return null;
    }

    return (
        <div className={authorsSection}>
            {showAuthor && author && <PersonDescription person={author} />}
            {showExpert && expert && <PersonDescription person={expert} />}
        </div>
    );
};

const authorsSection = css({
    mb: 4,

    md: {
        mb: 3
    }
});
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {IRPStore} from "../../../app/rp_reducer";
import {PersonDescription} from "./PersonDescription";

export const AuthorsSection = () => {
    const author = useSelector((state: IRPStore) => state.article.detail.article?.author);
    const expert = useSelector((state: IRPStore) => state.article.detail.article?.expert);

    const showAuthor = !!(author?.image_url && author.description.length > 0);
    const showExpert = !!(expert?.image_url && expert.description.length > 0);

    if (!showAuthor && !showExpert) {
        return null;
    }

    return (
        <div className={authorsSection}>
            {showAuthor && author && <PersonDescription person={author} />}
            {showExpert && expert && <PersonDescription person={expert} />}
        </div>
    );
};

const authorsSection = css({
    mb: 4,

    md: {
        mb: 3
    }
});
